/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'confluence-3p-connector-nudge': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-3p-connector-nudge/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-messaging-research-recruitment': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-messaging-research-recruitment/placements/in-app/screen-space-flags/render'
			),
	),
	'test-screen-space-flags-message': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-screen-space-flags-message/placements/in-app/screen-space-flags/render'
			),
	),
};
